import { useContextKeycloak } from "@/app/module/keycloak/index";
import { setTrackerUserID } from "@/app/openreplay/init-openreplay";
import { createContext, useContext, useEffect } from "react";
import { useProfile } from "./profile-hooks";

type ContextProfileType = ReturnType<typeof useProfile>;
export const profileContext = createContext<ContextProfileType | null>(null);

export function useContextProfile() {
  const context = useContext(profileContext);

  if (!context) {
    throw new Error(
      "useContextProfile must be used within a ContextProfileProvider"
    );
  }

  return context;
}

export function ContextProfileProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const profileContextValue = useProfile();
  const { fetchProfile, profile, clearProfileCache } = profileContextValue;
  const { authorize } = useContextKeycloak();

  useEffect(() => {
    if (authorize) {
      fetchProfile().catch(console.error);
    } else {
      clearProfileCache();
    }
  }, [authorize]);

  useEffect(() => {
    if (profile?.Login) {
      setTrackerUserID(profile.Login);
    }
  }, [profile?.Login]);

  if (authorize && !profile) {
    return null;
  }

  return (
    <profileContext.Provider value={profileContextValue}>
      {children}
    </profileContext.Provider>
  );
}
